// The Replay community Discord, via the www.replay.io redirect that owns the current invite: the
// canonical way to reach the Replay team. Import this everywhere a Discord link is rendered or named.
export const DISCORD_URL = 'https://www.replay.io/discord'

export const SUPPORT_EMAIL = 'support@replay.io'
